  function checkWG(section){
  
    var zipCodes = ['91701','91708','91709','91710','91729','91730','91737','91739','91743','91758',
                    '91761','91762','91763','91764','91784','91785','91786'];
    
    var zip = document.getElementById("wg_zipcode").value;
    var index = zipCodes.indexOf(zip);

    if(!isNumeric(zip)){
        document.getElementById("zip-error"+section).style.display = "block"
        document.getElementById("wg-available"+section).style.display = "none"
        document.getElementById("wg-unavailable"+section).style.display = "none"
    }else if(index > -1)
    {
        console.log(index);
        document.getElementById("zip-error"+section).style.display = "none"
        document.getElementById("wg-available"+section).style.display = "block"
        document.getElementById("wg-unavailable"+section).style.display = "none"
    }
    else{
        document.getElementById("zip-error"+section).style.display = "none"
        document.getElementById("wg-available"+section).style.display = "none"
        document.getElementById("wg-unavailable"+section).style.display = "block"
    }
    
  }

function isNumeric(inputText) {
  var numericRegex = /^[0-9]+$/;
  return numericRegex.test(inputText);
}
